import React from 'react';
import PropTypes from 'prop-types';
import {NavLink} from 'react-router-dom';
import css from './Breadcrumbs.module.scss';

const Breadcrumbs = ({items}) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <nav className={css.breadcrumbs} aria-label="Breadcrumb">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <React.Fragment key={item.to || item.label}>
            {index > 0 && <span className={css.separator}>/</span>}
            <BreadcrumbsSegment item={item} isLast={isLast} />
          </React.Fragment>
        );
      })}
    </nav>
  );
};

const BreadcrumbsSegment = ({item, isLast}) => {
  if (isLast) {
    return <span className={css.current}>{item.label}</span>;
  }
  if (item.to) {
    return (
      <NavLink to={item.to} className={css.link} onClick={item.onClick}>
        {item.label}
      </NavLink>
    );
  }
  return <span className={css.item}>{item.label}</span>;
};

Breadcrumbs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      to: PropTypes.string,
      onClick: PropTypes.func,
    }),
  ).isRequired,
};

export default Breadcrumbs;
